module.exports = __webpack_public_path__ + "static/media/programming.dde07d54.svg";